import React from "react";
import S from "./TitleParts.styled";
import { getHighlightColor, isLight } from "@/src/helpers";
import { ColorOptions, IWPTitleParts } from "@/src/types";

export interface ITitlePartsProps {
  titleParts: IWPTitleParts;

  backgroundColor: ColorOptions;
}

const TitleParts: React.FC<ITitlePartsProps> = ({
  titleParts,
  backgroundColor,
}) => {
  const isLightColor = isLight(backgroundColor);

  const renderTitleParts = titleParts?.map(({ titlePart, color }, index) => {
    const key = `${titlePart}-${index}`;

    const getColor = () => {
      if (color === "highlight") {
        return getHighlightColor(backgroundColor);
      } else {
        return backgroundColor === "yellow"
          ? "brown"
          : backgroundColor === "pink"
            ? "creme"
            : isLightColor
              ? "black"
              : "creme";
      }
    };

    const separatedTitleParts = () => {
      const titleParts = titlePart?.split(" ");

      return titleParts?.map((part, index) => {
        return (
          <React.Fragment key={index}>
            <S.TitlePart $color={getColor()}>
              {part}

              <span>&nbsp;</span>
            </S.TitlePart>
          </React.Fragment>
        );
      });
    };

    return <React.Fragment key={key}>{separatedTitleParts()}</React.Fragment>;
  });
  return <S.Title>{renderTitleParts}</S.Title>;
};

export default TitleParts;
